module.exports = __webpack_public_path__ + "img/crystal.0553136d.png";